module.exports = __webpack_public_path__ + "img/walletwat.ch.e2a32a6d.png";